/* eslint-disable spaced-comment */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { CoverageForFilter } from '../../ViewMember/coverage/coverage-filter/CoverageForFilter';
import { useSelector } from 'react-redux';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import backArrowIcon from 'src/Admin/img/arrow_back.svg';
import plusIcon from '../../../img/plus white.svg';
import ButtonWithMenu from '../ButtonWithMenu';
import { AuditButtonOptions } from 'src/constants';
import './header.styles.scss';

const Header = (props) => {
  const { SuperUser } = props;
  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const FEATURES = Features_Setting;
  const { selectedMember, memberList } = useSelector(
    (state) => state.memberModule,
  );
  const [initialMember, setInitialMember] = useState(undefined);
  const [memberOptions, setMemberOptions] = useState([]);
  const [isPermissionAuditLog, setIsPermissionAuditLog] = useState(false);
  useEffect(() => {
    const managePermissionAuditLogFlag =
      FEATURES &&
      FEATURES?.find((feature) => feature.Name === 'ShowPermissionAuditLog');
    managePermissionAuditLogFlag && managePermissionAuditLogFlag.Status === true
      ? setIsPermissionAuditLog(true)
      : setIsPermissionAuditLog(false);
  }, [FEATURES]);

  useEffect(() => {
    setInitialMember(selectedMember);
  }, []);

  useEffect(() => {
    const memberOption = [];
    if (memberList?.length > 0 && initialMember !== undefined) {
      if (initialMember?.mType === 'Employee' && memberList?.length > 1) {
        memberOption.push({
          label: `Family (${memberList?.length})`,
          value: `${memberList[0].OID}_Family (${memberList.length})`,
        });
        // eslint-disable-next-line array-callback-return
        memberList.map((m) => {
          memberOption.push({
            label: m.name,
            value: `${m.OID}_${m.name}`,
          });
        });
      } else {
        memberList?.length > 1 &&
          memberOption.push({
            label: `Family (${memberList?.length})`,
            value: `${memberList[0].OID}_Family (${memberList.length})`,
          });
        memberList.map((m) => {
          memberOption.push({
            label: m.name,
            value: `${m.OID}_${m.name}`,
          });
          return;
        });
      }
    }
    setMemberOptions(memberOption);
  }, [memberList, initialMember]);

  return (
    <Row className="mt-0 ml-0 mr-0 container-title d-flex align-items-center common-header-admin">
      <Col className="back-arrow">
        <Link
          to={props.linkTo}
          state={{ ...props.preserveData }}
          search={props.search}
          className="redirect-arrow p-0"
        >
          <img src={backArrowIcon} alt="logo" />
        </Link>
      </Col>
      <Col>
        <h1 id="greetings-time" className=" p-0">
          {props.header}
        </h1>
      </Col>
      {props.mandatoryLabel ? (
        <Col className="mandatory-text">
          <span className="help-text" role="alert">
            {props.mandatoryLabel}
          </span>
        </Col>
      ) : null}
      {props.addNewLinkTo ? (
        <Col className={`${props.className} text-right p-0`}>
          <Link to={props.addNewLinkTo} state={{ ...props.preserveData }}>
            <GenericButton variant={props?.buttonVarient || 'primary'}>
              {props?.buttonVarient !== 'secondary' && (
                <span>
                  <img id="plus-img" alt="Plus Icon" src={plusIcon} />
                </span>
              )}
              {props.addNewHeader}
            </GenericButton>
          </Link>
        </Col>
      ) : null}
      {props.dropdownLabel ? (
        <Col className="title-dropdown">
          <span className="label">{props.dropdownLabel}</span>
          <div className="member-dropdown">
            <CoverageForFilter
              coverageFor={memberOptions}
              coverageChangeHandler={props.coverageChangeHandler}
              activeCoverage={
                selectedMember?.label.includes('Family (')
                  ? { label: selectedMember.label, value: selectedMember.ID }
                  : props?.selectedUser
              }
            />
          </div>
        </Col>
      ) : null}
      {props.auditHistoryLink ? (
        <Col className={`${props.className} text-right p-0`} md={3}>
          {(SuperUser === true || props?.viewAuditLogButton) &&
          !isPermissionAuditLog ? (
            <div className={`text-right p-0`}>
              <ButtonWithMenu
                options={AuditButtonOptions}
                title="AUDIT LOG"
                itemAction={(item) => props.handleAuditButtonClick(item.type)}
                parentClassName="audit-log-button"
              />
            </div>
          ) : null}
        </Col>
      ) : null}
    </Row>
  );
};

export default Header;
